import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useAssetsAbandonDetailsModel } from './details/assetsAbandonDetailsModel'
import { useAssetsAbandonModel } from '../assetsAbandonModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportData,setPrint } = useAssetsAbandonModel()
    const { resetEditCatch } = useAssetsAbandonDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let AssetsAbandonEditKey = '2-4-2'
        let isFindNav = findNav(AssetsAbandonEditKey)
        if (!isFindNav) {
            addNav(AssetsAbandonEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资报废跳转详情',
                type: 'warning',
                text: '您还有物资报废详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsAbandonEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_C_AD}>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('2-4-1', { id: '', mode: 'add' })}>
            <PlusOutlined />
                报废
            </Button>
            </YhAuth>
            {/* <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                更新
            </Button> */}
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_C_PRINT}>
            <Button className="mr-5" type="link" shape="round"  disabled={selectedRowKeys.length !== 1}
                onClick={() => setPrint(true)}>
                打印
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_C_EX}>
            <Button className="mr-5" type="link" shape="round" onClick={() => exportData()}>
                导出
            </Button>
            </YhAuth>
            
            <div style={{ fontSize: '17px', fontWeight: 'bolder', float: 'right' }}>
                <span>
                    报废数量：<span style={{ color: 'green' }}>{statistics?.totalNum}</span>
                </span>
                <span style={{ marginLeft: '20px' }}>
                    报废金额：<span style={{ color: 'red' }}>{statistics?.totalAmount}</span>
                </span>
            </div>
        </>
    )

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
